import { jsx as _jsx } from "react/jsx-runtime";
import { Banner, Spinner } from "@neru/ui";
import { useAuthService } from "pkce-hook";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Emitter } from "../../services";
import { getLogger } from "../../utils";
import { AccessDenied } from "../../utils/errors";
var SLACK_TIME = 5;
var log = getLogger("SecureRouteWithToken");
export var SecureRouteWithToken = function(param) {
    var hasPortalSession = param.hasPortalSession;
    var _useAuthService = useAuthService(), authError = _useAuthService.authError, isAuthenticated = _useAuthService.isAuthenticated, isPending = _useAuthService.isPending, login = _useAuthService.login;
    var navigate = useNavigate();
    var location = useLocation();
    var hash = location.hash, pathname = location.pathname;
    var hasAuthentication = isAuthenticated();
    useEffect(function() {
        if (isPending()) {
            log.info("Authorization is pending...");
            var timeout = setTimeout(function() {
                log.info("Resetting authorization...");
                if (localStorage.getItem("vch.auth-handshake")) {
                    localStorage.removeItem("vch.auth-handshake");
                    localStorage.removeItem("vch.auth");
                    navigate("/");
                }
            }, SLACK_TIME * 1000);
            return function() {
                clearTimeout(timeout);
            };
        } else if (authError) {
            Emitter.emit("error", new AccessDenied(authError));
        } else if (!hasAuthentication) {
            log.info("Not authenticated, login...");
            if (hasPortalSession === false) {
                window.location.replace("".concat(window.location.origin, "/sign-in?redirect=").concat(window.location.pathname + window.location.hash));
            } else {
                if (!localStorage.getItem("vch.navigate_to")) {
                    localStorage.setItem("vch.navigate_to", pathname + hash);
                }
                login();
            }
        }
    }, [
        authError,
        hasPortalSession,
        hash,
        hasAuthentication,
        isPending,
        login,
        navigate,
        pathname
    ]);
    if (authError) {
        return /*#__PURE__*/ _jsx(Banner, {
            connotation: "alert",
            "data-testid": "alert-banner-auth",
            message: "Session expired. Please sign in again.",
            open: true
        });
    }
    if (hasAuthentication) {
        return /*#__PURE__*/ _jsx(Outlet, {});
    }
    return /*#__PURE__*/ _jsx(Spinner, {
        "data-testid": "pending-token-auth"
    });
};

//# sourceMappingURL=SecureRouteWithToken.js.map